<template>
  <div>
    <div v-if="!isLengthError" class="hotel_key_word" @mousedown.capture.prevent.stop ref="maxBoxRef"
         style="border-radius: 8px">
      <div class="hotel_key_word_item" v-if="hotelRes && hotelRes.cities && hotelRes.cities.length">
        <div class="left">
          <i class="el-icon-office-building" style="margin-bottom: 6px;"></i>
          <span>城市</span>
        </div>
        <div class="right">
          <div class="hotel_item" v-for="item in hotelRes.cities" :key="item.hotelId" @click="toHotelList(item, 'city')">
            <div>
              <span style="margin-right: 8px" v-html="item.nameCn"></span>
              <span v-html="item.name" v-show="item.nameCn !== item.name"></span>
            </div>
            <div style="white-space: nowrap;font-size: 11px">
              <span style="margin-right: 25px;color: #808080">附近约{{ item.hotelCount }}家酒店</span>
              <span v-if="item.countryNameCn">
                <span>{{ item.provinceNameCn }}</span>
                <span>
                  <span v-if="item.provinceNameCn && item.countryNameCn">,</span>{{ item.countryNameCn }}
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="hotel_key_word_item" v-if="hotelRes && hotelRes.otherCityHotels && hotelRes.otherCityHotels.length">
        <div class="left">
          <i class="iconfont icon-guojijiudian" style="margin-bottom: 6px;"/>
          <span>酒店</span>
        </div>
        <div class="right">
          <div class="hotel_item" v-for="item in hotelRes.otherCityHotels" :key="item.hotelId"
               @click="toHotelDetail(item)">
            <div style="line-height: 18px">
              <span style="margin-right: 8px" v-html="item.hotelNameCn"></span>
              <span v-html="item.hotelName" v-show="item.hotelNameCn !== item.hotelName"></span>
            </div>
            <div style="white-space: nowrap;font-size: 11px">
              {{ item.city }}
              <span v-if="item.country" v-html="item.country ? ',' + item.country : ''"></span>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="hotel_key_word_item" v-if="hotelRes && hotelRes.viewPoiList && hotelRes.viewPoiList.length">
          <div class="left">
            <i class="iconfont icon-jingdian" style="margin-bottom: 6px;"></i>
            <span>景点</span>
          </div>
          <div class="right">
            <div class="hotel_item" v-for="item in hotelRes.viewPoiList" :key="item.hotelId" @click="toHotelList(item, 'poi')">
              <div>
                <span style="margin-right: 8px" v-html="item.nameCn"></span>
                <span v-html="item.name" v-show="item.nameCn !== item.name"></span>
              </div>
              <div style="white-space: nowrap;font-size: 11px">
                <span style="margin-right: 25px;color: #808080">附近约{{ item.hotelCount }}家酒店</span>
                {{ item.cityNameCn }}
                <span v-if="item.countryNameCn" v-html="item.countryNameCn ? ',' + item.countryNameCn : ''"></span>
              </div>
            </div>
          </div>
        </div>
        <div class="hotel_key_word_item" v-if="hotelRes && hotelRes.transportPoiList && hotelRes.transportPoiList.length">
          <div class="left">
            <i class="iconfont icon-airplane" style="margin-bottom: 6px;"></i>
            <span>交通枢纽</span>
          </div>
          <div class="right">
            <div class="hotel_item" v-for="item in hotelRes.transportPoiList" :key="item.hotelId" @click="toHotelList(item, 'poi')">
              <div>
                <span style="margin-right: 8px" v-html="item.nameCn"></span>
                <span v-html="item.name" v-show="item.nameCn !== item.name"></span>
              </div>
              <div style="white-space: nowrap;font-size: 11px">
                <span style="margin-right: 25px;color: #808080">附近约{{ item.hotelCount }}家酒店</span>
                {{ item.cityNameCn }}
                <span v-if="item.countryNameCn" v-html="item.countryNameCn ? ',' + item.countryNameCn : ''"></span>
              </div>
            </div>
          </div>
        </div>
        <div class="hotel_key_word_item" v-if="hotelRes && hotelRes.businessPoiList && hotelRes.businessPoiList.length">
          <div class="left">
            <i class="iconfont icon-didian1" style="margin-bottom: 6px;"></i>
            <span>商圈</span>
          </div>
          <div class="right">
            <div class="hotel_item" v-for="item in hotelRes.businessPoiList" :key="item.hotelId" @click="toHotelList(item, 'poi')">
              <div>
                <span style="margin-right: 8px" v-html="item.nameCn"></span>
                <span v-html="item.name" v-show="item.nameCn !== item.name"></span>
              </div>
              <div style="white-space: nowrap;font-size: 11px">
                <span style="margin-right: 25px;color: #808080">附近约{{ item.hotelCount }}家酒店</span>
                {{ item.cityNameCn }}
                <span v-if="item.countryNameCn" v-html="item.countryNameCn ? ',' + item.countryNameCn : ''"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="error_box" v-else>
      请输入至少两个字符
    </div>
  </div>
</template>

<script>
export default {
  name: 'HotelKeyWord',
  props: ['hotelRes', 'isLengthError', 'regionId'],
  methods: {
    moveScroll () {
     let el = this.$refs['maxBoxRef']
      if (el) {
        el.scrollTop = 0
      }
    },
    toHotelDetail (item) {
      this.setHistory(item, 'searchHotelHistory')
      this.$emit('toHotelDetail', item)
    },
    toHotelList (item, type) {
      this.setHistory(item, type === 'poi' ? 'searchPoiHistory' : 'city')
      this.$emit('toHotelList', item, type)
    },
    setHistory (item, key) {
      let compareKey = ''
      if (key === 'searchHotelHistory') {
        compareKey = 'sourceHotelNameCn'
      } else if (key === 'searchPoiHistory') {
        compareKey = 'sourceNameCn'
      } else if (key === 'city') {
        compareKey = 'sourceNameCn'
      }
      item.type = key
      let history = localStorage.getItem('searchResHistory')
      if (history) {
        let historyArr = JSON.parse(history)
        let exist = historyArr.some(i => item[compareKey] === i[compareKey])
        if (!exist) {
          historyArr.unshift(item)
        }
        if (historyArr.length > 5) {
          historyArr.pop()
        }
        localStorage.setItem('searchResHistory', JSON.stringify(historyArr))
      } else {
        localStorage.setItem('searchResHistory', JSON.stringify([item]))
      }
    }
  }
}
</script>

<style scoped lang="less">
.error_box {
  position: absolute;
  width: 535px;
  height: 40px;
  background-color: #fff;
  top: 92px;
  right: -242px;
  z-index: 50;
  box-shadow: 0 2px 2px #eaeaea;
  color: red;
  font-size: 15px;
  padding: 15px;
  border-radius: 8px;
}
.hotel_key_word {
  position: absolute;
  width: 835px;
  max-height: 400px;
  background-color: #fff;
  overflow: auto;
  top: 90px;
  right: -542px;
  z-index: 50;
  box-shadow: 0 2px 2px #eaeaea;

  .hotel_key_word_item {
    display: flex;
    column-gap: 15px;

    &:not(:last-child) {
      border-bottom: 1px solid #1e50f0;
    }
  }

  .left {
    width: 100px;
    text-align: center;
    padding: 15px 0;
    border-right: 1px solid #1e50f0;
  }

  .right {
    padding: 10px;
    width: 745px;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    align-self: center;

    .hotel_item {
      display: flex;
      padding-bottom: 12px;
      justify-content: space-between;
      column-gap: 35px;

      &:first-child {
        margin-top: 12px;
      }

      &:not(:last-child) {
        margin-bottom: 12px;
        border-bottom: 1px solid #f2f2f2;
      }
    }
  }

  .no_res {
    text-align: center;
    width: 745px;
    position: relative;

    .info {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;

      p {
        font-size: 13px;
        margin-top: 8px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/booking/components/HotelKeyWord.vue